// extracted by mini-css-extract-plugin
module.exports = {"toggle":"styles_toggle__3WGxY","label":"styles_label__aEnzh","switch":"styles_switch__1AEr1","input":"styles_input__10nkj","slider":"styles_slider__3RRn6"};